/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, InputAdornment, Tooltip, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import Service from '../Service';
import Chip from '@material-ui/core/Chip';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { AlertDialog } from './../../Common/AlertDialog';
function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function AddSpecialOrderListing(props) {
    const screenCode = 'ADDSPECIALORDER';
    let encrypted = "";
    const navigate = useNavigate();
    const [date, setDate] = useState(new Date());
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        dataID: date.toISOString().split('T')[0]
    });
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [approveVPUSpecialOrderDetails, setApproveVPUSpecialOrderDetails] = useState();
    const [rejectVPUSpecialOrderDetails, setRejectVPUSpecialOrderDetails] = useState();
    const [message, setMessage] = useState("Special Order Approve Confirmation");
    const [message2, setMessage2] = useState("Special Order Reject Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [EnableConfirmMessage2, setEnableConfirmMessage2] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [renderSearchForm, setRenderSearchForm] = useState(true);
    const [specialOrders, setSpecialOrders] = useState([]);
    const [specialOrderCreated, setSpecialOrderCreated] = useState(false);

    const addSpecialOrderSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number(),
        dateID: Yup.date().min(1, 'Please Select Date').required('Date required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            dateID: formData.dataID
        },
        validationSchema: addSpecialOrderSearchSchema,
        onSubmit: (values) => {
            trackPromise(GetSpecialOrdersByVccDate())
        }
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };



    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        loadAddedSpecialOrders();
    }, []);

    useEffect(() => {
        if (specialOrderCreated) {
            GetSpecialOrdersByVccDate();
        }
    }, [specialOrderCreated]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWADDSPECIALORDER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
        });
        trackPromise(GetAllGroups());
    }

    async function loadAddedSpecialOrders() {
        const res = await GetSpecialOrdersByVccDate();

        if (res != null) {
            setSpecialOrders(res);
        }
    }


    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setTableData([]);
        setIsLoading(false);
        setRenderSearchForm(false);
    }, [formik.values.operationEntityID, formik.values.dateID]);

    async function GetAllGroups() {
        var res = await Service.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await Service.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    const handleSpecialOrderCreated = () => {
        setSpecialOrderCreated(true);
    };


    async function clearAll() {
        setTableData([]);
    }

    function handleClick(data) {
        encrypted = AESEncryptionParam(data.specialOrderID.toString());
        navigate('/dashboard/AddSpecialOrder/AddEdit/' + encrypted)
    }

    async function GetSpecialOrdersByVccDate() {
        var res = await Service.GetSpecialOrdersByVccDate(formik.values.operationEntityID, formik.values.dateID);
        if (res != null) {
            setTableData(res);
        }
    }

    async function ApproveVPUSpecialOrder(value) {
        let model = {
            specialOrderID: parseInt(value.specialOrderID),
            modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        var res = await Service.ApproveVPUSpecialOrder(model);
        if (res.statusCode === "Success") {
            toast.success(res.message);
            GetSpecialOrdersByVccDate();
        } else {
            toast.error(res.message);
        }
    }

    async function RejectVPUSpecialOrder(value) {
        let model = {
            specialOrderID: parseInt(value.specialOrderID),
            modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        var res = await Service.RejectVPUSpecialOrder(model);
        if (res.statusCode === "Success") {
            toast.success(res.message);
            GetSpecialOrdersByVccDate();
        } else {
            toast.error(res.message);
        }
    }

    async function ApproveVPUSpecialOrderPopUp(data) {
        setEnableConfirmMessage(true);
        setApproveVPUSpecialOrderDetails(data)
    }

    async function RejectVPUSpecialOrderPopUp(data) {
        setEnableConfirmMessage2(true);
        setRejectVPUSpecialOrderDetails(data)
    }

    function confirmData(y) {
        if (y) {
            ApproveVPUSpecialOrder(approveVPUSpecialOrderDetails);
        }
    }

    function confirmData2(y) {
        if (y) {
            RejectVPUSpecialOrder(rejectVPUSpecialOrderDetails);
        }
    }

    return (
        <> {isLoading ? (
            <LoadingComponent />
        ) : (
            <Page title="Add Special Order |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/AddSpecialOrder/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Add Special Order"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> All Fresh Collection Center</MenuItem>
                                        {operationEntityList.map((option) => (
                                            option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        fullWidth
                                        id="outlined-start-adornment"
                                        size="small"
                                        label="Date *"
                                        type="Date"
                                        value={formik.values.dateID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('dateID')}
                                        error={Boolean(touched.dateID && errors.dateID)}
                                        helperText={touched.dateID && errors.dateID}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"></InputAdornment>
                                        }}
                                    // inputProps={{
                                    //     min: new Date().toISOString().split('T')[0],
                                    // }}
                                    >
                                    </TextField>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            color='error'
                                            variant="outlined"
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Add Special Order" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">Special Order Code</TableCell>
                                                <TableCell align="left">Fresh Collection Center</TableCell>
                                                <TableCell align="left">SKU</TableCell>
                                                <TableCell align="left">Crop Name</TableCell>
                                                <TableCell align="right">Quantity</TableCell>
                                                <TableCell align="right">Price</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.specialOrderID}>
                                                    <TableCell align="left" component="th" scope="row">
                                                        {row.specialOrderCode}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.factoryName}
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row">
                                                        {row.productCode}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.productName}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {parseFloat(row.quantity).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {parseFloat(row.realizedPrice).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.statusID == 1 ?
                                                            <Chip size="small" label="Pending" style={{ color: 'orange' }} /> :
                                                            row.statusID == 2 ?
                                                                <Chip size="small" label="FDC Approved" style={{ color: 'green' }} /> :
                                                                row.statusID == 3 ?
                                                                    <Chip size="small" label="FDC Rejected" style={{ color: 'red' }} /> :
                                                                    row.statusID == 4 ?
                                                                        <Chip size="small" label="FCC Approved" style={{ color: 'green' }} /> :
                                                                        <Chip size="small" label="FCC Rejected" style={{ color: 'red' }} />
                                                        }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.statusID == 1 ?
                                                            <>
                                                                <Tooltip title="Edit Special Order">
                                                                    <IconButton aria-label="delete" onClick={() => handleClick(row)}>
                                                                        <EditIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Approve">
                                                                    <IconButton aria-label="delete" onClick={() => ApproveVPUSpecialOrderPopUp(row)}>
                                                                        <CheckIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Reject">
                                                                    <IconButton aria-label="delete" onClick={() => RejectVPUSpecialOrderPopUp(row)}>
                                                                        <CloseIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>
                                                            : '-'}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={8} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={8}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    onSpecialOrderCreated={handleSpecialOrderCreated}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to approve this Special Order ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData2} headerMessage={message2} viewPopup={EnableConfirmMessage2}
                            discription={"Are you sure want to reject this Special Order ?"} setViewPopup={setEnableConfirmMessage2} />
                    </Grid>
                </div>
            </Page>
        )}
        </>
    );
}